/**
 * Radiance Theme JS
 *
 * Dependencies:
 * - hoverintent.jquery.js
 *
 */



/**
 * Look under your chair! console.log FOR EVERYONE!
 *
 * @see http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
 */
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  jQuery(mainImageDomEl).attr('src', newImageSrc);
  if($('#product-gallery').hasClass('zoom-in')) { 
    jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: newImageSrc.replace('_large', '') } ); 
  } else {
    $(mainImageDomEl).parents('a').attr('href', newImageSrc);
  }
};

jQuery(function($) {
   
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('#thumbs.switch a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('#active-wrapper img')[0]);
  } );
  
  if($('#product-gallery').hasClass('zoom-in')) {  
    /* Initialize zoom on main product image */
    var mainProductImage = $('#active-wrapper img');
    if (mainProductImage.size()) {
      var zoomedSrc = $('#active-wrapper img').attr('src').replace('_large', '');
      $('#active-wrapper img')
        .wrap('<span style="display:inline-block"></span>')
        .css('display', 'block')
        .parent()
        .zoom( { url: zoomedSrc } );
    }
  }
});

/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var RADIANCE = {

  common : {
    init: function(){
      $('html').removeClass('no-js').addClass('js');
      setupDropdownMenus();
      searchPlaceholder();

      $('.nav-arrow', '#top-menu').each( function(){
        $(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
      });

    }
  },

  templateIndex : {
    init: function(){
      if( $("#carousel").length > 0 ){
       $("#carousel").scrollable({
    circular: true
    }).navigator({
      navi: "#carousel-slide-menu",
      naviItem: 'li'
    });

        if ( $("#carousel").find('.items li[class!=cloned]').length > 1 ) {
          window.api = $("#carousel").autoscroll({
            autoplay: true,
            api: true,
            interval: 7500
          })
          $("#carousel").hover(
              function() {
                api.pause();
                $(this).find('.browse').fadeIn('fast');
              },
              function() {
                api.play();
                $(this).find('.browse').fadeOut('fast');
              }
          );
        }

        $('#carousel-thumbs li:first a').addClass('active');
      }
    }
  },

  /*templateProduct : {
    init: function(){
      $('#product-actions').bind( 'submit', addToCart );
      $('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
    }
  },*/

  templateCart : {
    init: function(){
      $('#toggle-note').toggle(
        function(){ $('#checkout-addnote').find('textarea').show(); },
        function(){ $('#checkout-addnote').find('textarea').hide();  }
      );

    }
  }

}



/**
 * Fire function based upon attributes on the body tag.
 * This is the reason for "template" in layout/theme.liquid
 *
 * @see http://paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 */
var UTIL = {

  fire : function(func,funcname, args){
    var namespace = RADIANCE;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
      namespace[func][funcname](args);
    }
  },

  loadEvents : function(){
    var bodyId = document.body.id;

    // hit up common first.
    UTIL.fire('common');

    // do all the classes too.
    $.each(document.body.className.split(/\s+/),function(i,classnm){
      UTIL.fire(classnm);
      UTIL.fire(classnm,bodyId);
    });
  }

};
$(document).ready(UTIL.loadEvents);



/**
 * Balances the height of rows of products/collections.
 * Finds the tallest item in a row, makes each <li> in that row as tall as the tallest.
 */
$.fn.balanceRowHeight = function(numPerRow) {
  var nPerRow = numPerRow || 4;
  var nItems = $(this).find('li').length;
  var nRows = Math.round( nItems / nPerRow );

  for( var row = 1; row <= nRows; row++ ){
    var min = row * nPerRow - nPerRow;
    var max = row * nPerRow;
    var tallestInRow = 0;
    var tallestTitleInRow = 0;

    $(this).find('li').slice(min, max).each(function(){
      if( $(this).height() > tallestInRow ){
        tallestInRow = $(this).height();
      }
      if( $(this).find('.product-information:first').height() > tallestTitleInRow ){
        tallestTitleInRow = $(this).find('.product-information').height();
      }
    }).height(tallestInRow).addClass('generated-height');
  }

  return this;
};


/**
 * Balance product grid height after all images have loaded.
 */
$(window).load( function(){
  if( $('body').hasClass('templateIndex') ){
    // homepage has two grids, needs a bit of special treatment:
   // $('#featured-grid').balanceRowHeightDivs(3); - disabled for new layout responsive!
    $('#secondary-grid').balanceRowHeight(4);
    $('#collection-grid').balanceRowHeight(4);
  } else {
    $('.product-grid').balanceRowHeight(4);
  }
});



/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
  $('#top-menu .has-dropdown').hoverIntent( navRollOver, navRollOut );

  function navRollOver(e){
    $(this).addClass('active').find('ul:first').css('top', $(this).height()).show();
  }
  function navRollOut(e){
    $(this).removeClass('active').find('ul:first').hide();
  }

}



/**
 * Ajaxy add-to-cart
 */
/*function addToCart(e){

  if (typeof e !== 'undefined') e.preventDefault();

  var form      = $(this);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: function(jqXHR, textStatus, errorThrown){
      
      if (typeof(upsell_main) === "function") {
        upsell_main();
      }
      if (typeof(upsell_offer) === "function") { 
        upsell_offer(); 
        jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){ 
          // Original success code here - triggers when the upsell pop-up is closed 
          addToCartSuccess(jqXHR, textStatus, errorThrown);
        });
      } else { 
        //Original success code here
        addToCartSuccess(jqXHR, textStatus, errorThrown);
      }
    
       
    
    },
    cache: false
  });

}

function addToCartSuccess (jqXHR, textStatus, errorThrown){

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  $('#add-to-cart-msg').hide().addClass('success').html("Item added to cart! \u003ca href=\"\/cart\" title=\"view cart\"\u003eView cart and check out \u0026raquo;\u003c\/a\u003e").fadeIn();
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  $('#add-to-cart-msg').addClass('error').html(response.description).fadeIn('fast');
}*/

function updateCartDesc(data){
  var $cartLinkText = $('.cart-link .icon:first');

  switch(data.item_count){
    case 0:
      $cartLinkText.text('0 ' + "items");
      break;
    case 1:
      $cartLinkText.text('1 ' + "item");
      break;
    default:
      $cartLinkText.text(data.item_count + ' ' + "items");
      break;
  }
}



/**
 * Enable placeholder switcheroo in older browsers.
 * @see http://webdesignerwall.com/tutorials/cross-browser-html5-placeholder-text
 */
                         
/* Modernizr 2.0.6 (Custom Build) | MIT & BSD
 * Build: http://www.modernizr.com/download/#-input-iepp-cssclasses-load
 */
;window.Modernizr=function(a,b,c){function y(){e.input=function(a){for(var b=0,c=a.length;b<c;b++)p[a[b]]=a[b]in l;return p}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))}function x(a,b){return!!~(""+a).indexOf(b)}function w(a,b){return typeof a===b}function v(a,b){return u(prefixes.join(a+";")+(b||""))}function u(a){k.cssText=a}var d="2.0.6",e={},f=!0,g=b.documentElement,h=b.head||b.getElementsByTagName("head")[0],i="modernizr",j=b.createElement(i),k=j.style,l=b.createElement("input"),m=Object.prototype.toString,n={},o={},p={},q=[],r,s={}.hasOwnProperty,t;!w(s,c)&&!w(s.call,c)?t=function(a,b){return s.call(a,b)}:t=function(a,b){return b in a&&w(a.constructor.prototype[b],c)};for(var z in n)t(n,z)&&(r=z.toLowerCase(),e[r]=n[z](),q.push((e[r]?"":"no-")+r));e.input||y(),u(""),j=l=null,a.attachEvent&&function(){var a=b.createElement("div");a.innerHTML="<elem></elem>";return a.childNodes.length!==1}()&&function(a,b){function s(a){var b=-1;while(++b<g)a.createElement(f[b])}a.iepp=a.iepp||{};var d=a.iepp,e=d.html5elements||"abbr|article|aside|audio|canvas|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",f=e.split("|"),g=f.length,h=new RegExp("(^|\\s)("+e+")","gi"),i=new RegExp("<(/*)("+e+")","gi"),j=/^\s*[\{\}]\s*$/,k=new RegExp("(^|[^\\n]*?\\s)("+e+")([^\\n]*)({[\\n\\w\\W]*?})","gi"),l=b.createDocumentFragment(),m=b.documentElement,n=m.firstChild,o=b.createElement("body"),p=b.createElement("style"),q=/print|all/,r;d.getCSS=function(a,b){if(a+""===c)return"";var e=-1,f=a.length,g,h=[];while(++e<f){g=a[e];if(g.disabled)continue;b=g.media||b,q.test(b)&&h.push(d.getCSS(g.imports,b),g.cssText),b="all"}return h.join("")},d.parseCSS=function(a){var b=[],c;while((c=k.exec(a))!=null)b.push(((j.exec(c[1])?"\n":c[1])+c[2]+c[3]).replace(h,"$1.iepp_$2")+c[4]);return b.join("\n")},d.writeHTML=function(){var a=-1;r=r||b.body;while(++a<g){var c=b.getElementsByTagName(f[a]),d=c.length,e=-1;while(++e<d)c[e].className.indexOf("iepp_")<0&&(c[e].className+=" iepp_"+f[a])}l.appendChild(r),m.appendChild(o),o.className=r.className,o.id=r.id,o.innerHTML=r.innerHTML.replace(i,"<$1font")},d._beforePrint=function(){p.styleSheet.cssText=d.parseCSS(d.getCSS(b.styleSheets,"all")),d.writeHTML()},d.restoreHTML=function(){o.innerHTML="",m.removeChild(o),m.appendChild(r)},d._afterPrint=function(){d.restoreHTML(),p.styleSheet.cssText=""},s(b),s(l);d.disablePP||(n.insertBefore(p,n.firstChild),p.media="print",p.className="iepp-printshim",a.attachEvent("onbeforeprint",d._beforePrint),a.attachEvent("onafterprint",d._afterPrint))}(a,b),e._version=d,g.className=g.className.replace(/\bno-js\b/,"")+(f?" js "+q.join(" "):"");return e}(this,this.document),function(a,b,c){function k(a){return!a||a=="loaded"||a=="complete"}function j(){var a=1,b=-1;while(p.length- ++b)if(p[b].s&&!(a=p[b].r))break;a&&g()}function i(a){var c=b.createElement("script"),d;c.src=a.s,c.onreadystatechange=c.onload=function(){!d&&k(c.readyState)&&(d=1,j(),c.onload=c.onreadystatechange=null)},m(function(){d||(d=1,j())},H.errorTimeout),a.e?c.onload():n.parentNode.insertBefore(c,n)}function h(a){var c=b.createElement("link"),d;c.href=a.s,c.rel="stylesheet",c.type="text/css";if(!a.e&&(w||r)){var e=function(a){m(function(){if(!d)try{a.sheet.cssRules.length?(d=1,j()):e(a)}catch(b){b.code==1e3||b.message=="security"||b.message=="denied"?(d=1,m(function(){j()},0)):e(a)}},0)};e(c)}else c.onload=function(){d||(d=1,m(function(){j()},0))},a.e&&c.onload();m(function(){d||(d=1,j())},H.errorTimeout),!a.e&&n.parentNode.insertBefore(c,n)}function g(){var a=p.shift();q=1,a?a.t?m(function(){a.t=="c"?h(a):i(a)},0):(a(),j()):q=0}function f(a,c,d,e,f,h){function i(){!o&&k(l.readyState)&&(r.r=o=1,!q&&j(),l.onload=l.onreadystatechange=null,m(function(){u.removeChild(l)},0))}var l=b.createElement(a),o=0,r={t:d,s:c,e:h};l.src=l.data=c,!s&&(l.style.display="none"),l.width=l.height="0",a!="object"&&(l.type=d),l.onload=l.onreadystatechange=i,a=="img"?l.onerror=i:a=="script"&&(l.onerror=function(){r.e=r.r=1,g()}),p.splice(e,0,r),u.insertBefore(l,s?null:n),m(function(){o||(u.removeChild(l),r.r=r.e=o=1,j())},H.errorTimeout)}function e(a,b,c){var d=b=="c"?z:y;q=0,b=b||"j",C(a)?f(d,a,b,this.i++,l,c):(p.splice(this.i++,0,a),p.length==1&&g());return this}function d(){var a=H;a.loader={load:e,i:0};return a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=r&&!s,u=s?l:n.parentNode,v=a.opera&&o.call(a.opera)=="[object Opera]",w="webkitAppearance"in l.style,x=w&&"async"in b.createElement("script"),y=r?"object":v||x?"img":"script",z=w?"img":y,A=Array.isArray||function(a){return o.call(a)=="[object Array]"},B=function(a){return Object(a)===a},C=function(a){return typeof a=="string"},D=function(a){return o.call(a)=="[object Function]"},E=[],F={},G,H;H=function(a){function f(a){var b=a.split("!"),c=E.length,d=b.pop(),e=b.length,f={url:d,origUrl:d,prefixes:b},g,h;for(h=0;h<e;h++)g=F[b[h]],g&&(f=g(f));for(h=0;h<c;h++)f=E[h](f);return f}function e(a,b,e,g,h){var i=f(a),j=i.autoCallback;if(!i.bypass){b&&(b=D(b)?b:b[a]||b[g]||b[a.split("/").pop().split("?")[0]]);if(i.instead)return i.instead(a,b,e,g,h);e.load(i.url,i.forceCSS||!i.forceJS&&/css$/.test(i.url)?"c":c,i.noexec),(D(b)||D(j))&&e.load(function(){d(),b&&b(i.origUrl,h,g),j&&j(i.origUrl,h,g)})}}function b(a,b){function c(a){if(C(a))e(a,h,b,0,d);else if(B(a))for(i in a)a.hasOwnProperty(i)&&e(a[i],h,b,i,d)}var d=!!a.test,f=d?a.yep:a.nope,g=a.load||a.both,h=a.callback,i;c(f),c(g),a.complete&&b.load(a.complete)}var g,h,i=this.yepnope.loader;if(C(a))e(a,0,i,0);else if(A(a))for(g=0;g<a.length;g++)h=a[g],C(h)?e(h,0,i,0):A(h)?H(h):B(h)&&b(h,i);else B(a)&&b(a,i)},H.addPrefix=function(a,b){F[a]=b},H.addFilter=function(a){E.push(a)},H.errorTimeout=1e4,b.readyState==null&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",G=function(){b.removeEventListener("DOMContentLoaded",G,0),b.readyState="complete"},0)),a.yepnope=d()}(this,this.document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};
                         
function searchPlaceholder(){

  if(!Modernizr.input.placeholder){
    $('#top-search-input').focus(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
      input.val('');
      input.removeClass('placeholder');
      }
    }).blur(function() {
      var input = $(this);
      if (input.val() == '' || input.val() == input.attr('placeholder')) {
      input.addClass('placeholder');
      input.val(input.attr('placeholder'));
      }
    }).blur();
    $('[placeholder]').parents('form').submit(function() {
      $(this).find('[placeholder]').each(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
        input.val('');
      }
      })
    });
  }

}
      
var addToCart = (function () {
    var productForm = $(".product-options_form");

    productForm.attr('action', '#');
    productForm.submit(addItem);

    function addItem(e) {
        e.preventDefault();
        var submitSpan = $(this).find('.product-submit-span');
        submitSpan.text("ADDING");
        $.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: $(this).serialize(),
            success: function (resp) {
                getCart.activate(null, true);
                submitSpan.text("ADDED!");
                setTimeout(function () {
                    submitSpan.text("ADD TO BAG");
                }, 1500);
                $(".product-default").removeClass('is-active');
                $(".product-dropdown").removeClass('is-active');
            },
            error: function () {
                submitSpan.text("SOLD OUT");
            },
            dataType: 'json'
        })
        
    }
})();

var getCart = (function () {
    var ajaxCart = $("#ajax-cart"),
        cartAmounts = $(".cart-amount"),
        cartIconAmount = $(".cart-icon-amount"),
        cartTotal = $("#ajax-cart #cart-total"),
        cartLinks = $(".cart-link"),
        overlay = $("#cart-overlay"),
        cartItemTemplate = $("#cart-item-template").html(),
        itemsEntry = $("#ajax-cart .items-entry");

    //change default tags since they are the same as liquid
    var customTags = ['<%', '%>'];
    Mustache.parse(cartItemTemplate, customTags);
    Mustache.tags = customTags;

    //disable cart icon link if javascript enabled
    cartLinks.attr('href', 'javascript:;');
    cartLinks.click(activateCart);
    ajaxCart.click(function (e) { e.stopPropagation(); });
    ajaxCart.on("click", ".remove-item", removeCartItem);
    overlay.click(activateCart);

    function activateCart(e, fetchCart) {
        if (e) e.stopPropagation();
        if (ajaxCart.attr('data-active') === "true") {
            ajaxCart.fadeOut(200);
            ajaxCart.attr('data-active', 'false');
            $('body').removeClass('no-scroll-fixed');
            overlay.fadeOut(200);
        } else {
            ajaxCart.fadeIn(200);
            ajaxCart.attr('data-active', 'true');
            $('body').addClass('no-scroll-fixed');
            overlay.fadeIn(200);
            if (fetchCart) {
                getCart();
            }
        }
    }

    function getCart() {
        ajaxCart.addClass('loading');
        itemsEntry.html('');
        //get cart from shopify
        $.get('/cart.js', function (resp) {
            ajaxCart.removeClass('loading');
            if (resp.items.length > 0) {
                var newItems = document.createDocumentFragment();
                for (var i = 0; i < resp.items.length; i++) {
                    //create new element, add to doc frag
                    newItems.appendChild(createCartElement(resp.items[i], i));
                }
                //append frag to cart
                itemsEntry.html(newItems);
                updateCartInfo(resp.item_count, "$" + ((resp.total_price / 100).toFixed(2)));
            } else {
                updateCartInfo(0)
            }
        }, 'json');

        function createCartElement(item, index) {
            //create new element
            var div = document.createElement('div');
            div.setAttribute('class', 'ajax-cart_item');

            //render mustache template with prepped item
            prepItemObject();
            div.innerHTML = Mustache.render(cartItemTemplate, item);

            return div;

            function prepItemObject() {
                item.title = item.title.split('-')[0];
                item.displayPrice = (item.price / 100).toFixed(2);
                item.line_number = index + 1;
            }
        }
    }

    function updateCartInfo(itemAmount, totalPrice) {
        if (itemAmount) {
            cartAmounts.text(itemAmount);
            cartIconAmount.show();
        } else {
            cartAmounts.text('0');
            itemsEntry.html('<div class="ajax-cart_no-items"><p class="ajax-cart_no-items_text">No items in bag!</p></div>');
            cartTotal.text('$0.00');
            cartIconAmount.hide();
        }
        if (totalPrice) cartTotal.text(totalPrice);
    }

    function removeCartItem() {
        var itemId = $(this).attr('data-id'),
            cartItem = $(this).parents('.ajax-cart_item');

        cartItem.fadeOut(200);
        $.post('/cart/change.js', { quantity: 0, id: itemId }, function () {
            $.get('/cart.js', function (resp) {
                updateCartInfo(resp.items.length, "$" + ((resp.total_price / 100).toFixed(2)));
            }, 'json');
        }, 'json');
      

    }

    getCart();

    return {
        activate: activateCart
    }
})();
var cartPage = (function() {
    var editButtons = $(".js-cart-edit");

    if(editButtons.length) editButtons.click(function() {
        var item = $(this).parents('.ajax-cart_item');
        $(this).parent().hide();
        item.parent().find('.ajax-cart_update-button').show();
        item.find('.ajax-cart_c-quantity').show();
    });
})();